module.exports = __webpack_public_path__ + "media/images/pages/fig_dataPopulation_02-b5140ca16acda92ead2d2da2a94317a4.png";